import Cookies from 'js-cookie';
import { IFrameHelper } from '../sdk/IFrameHelper';
import {
  getBubbleView,
  getDarkMode,
  getWidgetStyle,
} from '../sdk/settingsHelper';
import {
  computeHashForUserData,
  getUserCookieName,
  hasUserKeys,
} from '../sdk/cookieHelpers';
import { addClasses, removeClasses } from '../sdk/DOMHelpers';
import { setCookieWithDomain } from '../sdk/cookieHelpers';
import { SDK_SET_BUBBLE_VISIBILITY } from 'shared/constants/sharedFrameEvents';
import { bubbleImg } from '../sdk/bubbleHelpers';
const runSDK = ({ baseUrl, websiteToken }) => {
  if (window.$chatwoot) {
    return;
  }

  const chatwootSettings = window.chatwootSettings || {};
  let locale = chatwootSettings.locale;
  let baseDomain = chatwootSettings.baseDomain;

  if (chatwootSettings.useBrowserLanguage) {
    locale = window.navigator.language.replace('-', '_');
  }

  window.$chatwoot = {
    baseUrl,
    baseDomain,
    hasLoaded: false,
    hideMessageBubble: chatwootSettings.hideMessageBubble || false,
    isOpen: false,
    position: chatwootSettings.position === 'left' ? 'left' : 'right',
    websiteToken,
    locale,
    useBrowserLanguage: chatwootSettings.useBrowserLanguage || false,
    type: getBubbleView(chatwootSettings.type),
    launcherTitle: chatwootSettings.launcherTitle || '',
    showPopoutButton: chatwootSettings.showPopoutButton || false,
    widgetStyle: getWidgetStyle(chatwootSettings.widgetStyle) || 'standard',
    resetTriggered: false,
    darkMode: getDarkMode(chatwootSettings.darkMode),
    customerName: chatwootSettings.customerName || false,
    projectId: chatwootSettings.projectId || false,
    apiGateway: chatwootSettings.apiGateway || false,
    copyRightText: chatwootSettings.copyRightText || false,
    hideCopyRight: chatwootSettings.hideCopyRight || false,
    mode: chatwootSettings.mode || 'Chat',
    backgroundImage: chatwootSettings.backgroundImage || false,
    bubbleImg: chatwootSettings.bubbleImg || false,
    bubbleImgHeight: chatwootSettings.bubbleImgHeight || '25px',
    bubbleImgWidth: chatwootSettings.bubbleImgWidth || '25px',
    bubbleImgMargin: chatwootSettings.bubbleImgMargin || '16px 8px 12px 7px',

    toggle(state) {
      IFrameHelper.events.toggleBubble(state);
    },

    toggleBubbleVisibility(visibility) {
      let widgetElm = document.querySelector('.woot--bubble-holder');
      let widgetHolder = document.querySelector('.woot-widget-holder');
      if (visibility === 'hide') {
        addClasses(widgetHolder, 'woot-widget--without-bubble');
        addClasses(widgetElm, 'woot-hidden');
        window.$chatwoot.hideMessageBubble = true;
      } else if (visibility === 'show') {
        removeClasses(widgetElm, 'woot-hidden');
        removeClasses(widgetHolder, 'woot-widget--without-bubble');
        window.$chatwoot.hideMessageBubble = false;
      }
      IFrameHelper.sendMessage(SDK_SET_BUBBLE_VISIBILITY, {
        hideMessageBubble: window.$chatwoot.hideMessageBubble,
      });
    },

    popoutChatWindow() {
      IFrameHelper.events.popoutChatWindow({
        baseUrl: window.$chatwoot.baseUrl,
        websiteToken: window.$chatwoot.websiteToken,
        locale,
      });
    },

    setUser(identifier, user) {
      if (typeof identifier !== 'string' && typeof identifier !== 'number') {
        throw new Error('Identifier should be a string or a number');
      }

      if (!hasUserKeys(user)) {
        throw new Error(
          'User object should have one of the keys [avatar_url, email, name]'
        );
      }

      const userCookieName = getUserCookieName();
      const existingCookieValue = Cookies.get(userCookieName);
      const hashToBeStored = computeHashForUserData({ identifier, user });
      if (hashToBeStored === existingCookieValue) {
        return;
      }

      window.$chatwoot.identifier = identifier;
      window.$chatwoot.user = user;
      IFrameHelper.sendMessage('set-user', { identifier, user });

      setCookieWithDomain(userCookieName, hashToBeStored, {
        baseDomain,
      });
    },

    setCustomAttributes(customAttributes = {}) {
      if (!customAttributes || !Object.keys(customAttributes).length) {
        throw new Error('Custom attributes should have atleast one key');
      } else {
        IFrameHelper.sendMessage('set-custom-attributes', { customAttributes });
      }
    },

    deleteCustomAttribute(customAttribute = '') {
      if (!customAttribute) {
        throw new Error('Custom attribute is required');
      } else {
        IFrameHelper.sendMessage('delete-custom-attribute', {
          customAttribute,
        });
      }
    },

    setConversationCustomAttributes(customAttributes = {}) {
      if (!customAttributes || !Object.keys(customAttributes).length) {
        throw new Error('Custom attributes should have atleast one key');
      } else {
        IFrameHelper.sendMessage('set-conversation-custom-attributes', {
          customAttributes,
        });
      }
    },

    deleteConversationCustomAttribute(customAttribute = '') {
      if (!customAttribute) {
        throw new Error('Custom attribute is required');
      } else {
        IFrameHelper.sendMessage('delete-conversation-custom-attribute', {
          customAttribute,
        });
      }
    },

    setLabel(label = '') {
      IFrameHelper.sendMessage('set-label', { label });
    },

    removeLabel(label = '') {
      IFrameHelper.sendMessage('remove-label', { label });
    },

    setLocale(localeToBeUsed = 'en') {
      IFrameHelper.sendMessage('set-locale', { locale: localeToBeUsed });
    },

    setColorScheme(darkMode = 'light') {
      IFrameHelper.sendMessage('set-color-scheme', {
        darkMode: getDarkMode(darkMode),
      });
    },

    reset() {
      if (window.$chatwoot.isOpen) {
        IFrameHelper.events.toggleBubble();
      }

      Cookies.remove('cw_conversation');
      Cookies.remove(getUserCookieName());

      const iframe = IFrameHelper.getAppFrame();
      iframe.src = IFrameHelper.getUrl({
        baseUrl: window.$chatwoot.baseUrl,
        websiteToken: window.$chatwoot.websiteToken,
      });
    },
  };

  window.$chaata = {
    run: () => {
      let bubbleImage = bubbleImg;
      if (window.$chatwoot.bubbleImg) bubbleImage = window.$chatwoot.bubbleImg;
      window.$chaata.element = document.createElement('button');
      window.$chaata.icon = document.createElement(`img`);
      window.$chaata.icon.src = bubbleImage;
      window.$chaata.icon.setAttribute('alt', 'bubble icon');
      window.$chaata.icon.style.cssText = `height: ${window.$chatwoot.bubbleImgHeight};margin: ${window.$chatwoot.bubbleImgMargin};width: ${window.$chatwoot.bubbleImgWidth};`;
      window.$chaata.element.appendChild(window.$chaata.icon);
      window.$chaata.element.style.background =
        chatwootSettings.color ?? '#a01c4c';
      window.$chaata.element.style.foreground =
        chatwootSettings.foreground ?? '#ffffff';
      window.$chaata.element.style.borderRadius = '100px';
      window.$chaata.element.style.borderWidth = '0px';
      window.$chaata.element.style.bottom = '20px';
      window.$chaata.element.style.padding = '0px';
      window.$chaata.element.style.boxShadow = '0 8px 24px rgba(0, 0, 0, .16)';
      window.$chaata.element.style.cursor = 'pointer';
      window.$chaata.element.style.height = ' 64px';
      window.$chaata.element.style.position = 'fixed';
      window.$chaata.element.style.width = '64px';
      window.$chaata.element.style.zIndex = '2147483000';
      window.$chaata.element.style.userSelect = 'none';
      window.$chaata.element.name = 'chaata-widget-bubble';
      window.$chaata.element.setAttribute('name', 'chaata-widget-bubble');
      switch (chatwootSettings.position) {
        case 'right':
          window.$chaata.element.style.right = '20px';
          break;
        default:
          window.$chaata.element.style.left = '20px';
          break;
      }
      window.$chaata.element.addEventListener('click', () => {
        const iframe = IFrameHelper.createFrame({
          baseUrl,
          websiteToken,
        });
        if (iframe) {
          window.$chaata.toggle();
        } else {
          window.$chaata.toggle();
        }
      });
      document.body.appendChild(window.$chaata.element);
    },

    toggle: () => {
      var y = document.getElementsByClassName('woot-widget-bubble');
      if (y[0]) {
        setTimeout(window.$chatwoot.toggle, 500);
      } else {
        setTimeout(window.$chaata.toggle, 500);
      }
      window.$chaata.element.style.display = 'none';
    },
  };

  window.$chaata.run();
};

window.chatwootSDK = {
  run: runSDK,
};
